module.exports = "<template>\n    <compose view.bind=\"state.htmlPath\" ref=\"viewModel\"> </compose>\n</template>\n";